/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerdownloadstory3Inputs */

const en_checkinflyerdownloadstory3 = /** @type {(inputs: Checkinflyerdownloadstory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download as story image`)
};

const de_checkinflyerdownloadstory3 = /** @type {(inputs: Checkinflyerdownloadstory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Story-Bild laden`)
};

/**
* | output |
* | --- |
* | "Download as story image" |
*
* @param {Checkinflyerdownloadstory3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerdownloadstory3 = /** @type {((inputs?: Checkinflyerdownloadstory3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerdownloadstory3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerdownloadstory3(inputs)
	return de_checkinflyerdownloadstory3(inputs)
});
export { checkinflyerdownloadstory3 as "checkinFlyerDownloadStory" }